import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Undo2, Redo2, Pilcrow } from "lucide-react";

const TOOLS = [
  { id: "bold", icon: Bold, label: "Grassetto", run: (c) => c.toggleBold(), active: (e) => e.isActive("bold") },
  { id: "italic", icon: Italic, label: "Corsivo", run: (c) => c.toggleItalic(), active: (e) => e.isActive("italic") },
  { id: "p", icon: Pilcrow, label: "Paragrafo", run: (c) => c.setParagraph(), active: (e) => e.isActive("paragraph") },
  { id: "h2", icon: Heading2, label: "Titolo", run: (c) => c.toggleHeading({ level: 2 }), active: (e) => e.isActive("heading", { level: 2 }) },
  { id: "h3", icon: Heading3, label: "Sottotitolo", run: (c) => c.toggleHeading({ level: 3 }), active: (e) => e.isActive("heading", { level: 3 }) },
  { id: "ul", icon: List, label: "Elenco puntato", run: (c) => c.toggleBulletList(), active: (e) => e.isActive("bulletList") },
  { id: "ol", icon: ListOrdered, label: "Elenco numerato", run: (c) => c.toggleOrderedList(), active: (e) => e.isActive("orderedList") },
  { id: "undo", icon: Undo2, label: "Annulla", run: (c) => c.undo(), active: () => false },
  { id: "redo", icon: Redo2, label: "Ripeti", run: (c) => c.redo(), active: () => false },
];

function Toolbar({ editor }) {
  return (
    <div className="flex flex-wrap gap-1 border-b border-slate-200 bg-slate-50 p-1.5 rounded-t-xl">
      {TOOLS.map(({ id, icon: Icon, label, run, active }) => (
        <button key={id} type="button" title={label} aria-label={label} data-testid={`rte-btn-${id}`}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => run(editor.chain().focus()).run()}
          className={`w-8 h-8 inline-flex items-center justify-center rounded-md transition-colors ${active(editor) ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-200"}`}>
          <Icon style={{ width: 16, height: 16 }} />
        </button>
      ))}
    </div>
  );
}

export default function RichTextEditor({ value, onChange, testId = "rich-text-editor" }) {
  const editor = useEditor({
    extensions: [StarterKit.configure({ heading: { levels: [2, 3] }, link: false })],
    content: value || "",
    onUpdate: ({ editor: e }) => onChange(e.isEmpty ? "" : e.getHTML()),
    editorProps: { attributes: { class: "qf-rich min-h-[360px] p-4 focus:outline-none" } },
  });

  useEffect(() => {
    if (editor && value !== editor.getHTML() && !(value === "" && editor.isEmpty)) {
      editor.commands.setContent(value || "", { emitUpdate: false });
    }
  }, [editor, value]);

  if (!editor) return null;
  return (
    <div data-testid={testId} className="rounded-xl border border-slate-200 bg-card">
      <Toolbar editor={editor} />
      <EditorContent editor={editor} />
    </div>
  );
}
